import { module } from 'angular';

import { State } from './';
import { default as videoActionsName, VideoActions } from './video-actions.component.ajs';
import { default as videoWorkspaceName, VideoWorkspace } from './video-workspace.component.ajs';

export default module('contact.agent.contact-view.video', [State])
  .component(videoActionsName, new VideoActions())
  .component(videoWorkspaceName, new VideoWorkspace()).name;
